export default "__VITE_ASSET__ZUCBh04A__"